'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'tumbler',
    elem: 'input',
    tag: 'input',
    attrs: function attrs(_ref) {
        var id = _ref.id,
            name = _ref.name,
            value = _ref.value,
            onVal = _ref.onVal,
            offVal = _ref.offVal,
            checked = _ref.checked,
            disabled = _ref.disabled,
            labeledBy = _ref.labeledBy,
            onChange = _ref.onChange,
            _attrs = _ref.attrs,
            tabIndex = _ref.tabIndex;

        var values = [offVal || 'false', onVal || 'true'];
        var labelledBy = this.context.getLabel(id);

        return _extends({
            id: id,
            onChange: onChange,
            disabled: disabled,
            tabIndex: '-1',
            type: 'checkbox',
            name: name || id,
            autoComplete: 'off',
            'aria-hidden': 'true',
            checked: Boolean(checked), // Keep input controlled: http://bit.ly/2eY7an2
            'aria-labelledby': labelledBy,
            value: values[Number(!!checked)]
        }, _attrs);
    }
}, {
    contextTypes: {
        getLabel: _propTypes2.default.func
    }
});